import { jsx as _jsx } from "react/jsx-runtime";
import { CurrencySwitcherList } from "./CurrencySwitcherList/index.js";
export const CurrencySwitcher = ({ onItemClick, currencies, selectedCurrency }) => currencies && (_jsx(CurrencySwitcherList, { listItems: currencies.listItems, onItemClick: onItemClick, selectedCurrency: selectedCurrency }, "currency-switcher"));
